export const REQ = "Request";
export const RES = "Response";
export const ERR = "Error";

